import { Component } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { QR_List, QR_registro, QR_Estilo } from 'src/app/models/QR';
import { QrService } from 'src/app/service/qr.service';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/service/storage.service';
import { users } from 'src/app/models/Login';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/loading/loading.service';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent {
  loading$ = this.loadingService.loading$;
  [x: string]: any;
  myAngularxQrCode: string = '';
  qrCodeDownloadLink: SafeUrl = '';
  public usuario: users | undefined;
  esAdministrado: boolean = false;
  QR_List_List: QR_List[] = [];
  entidad: QR_registro | undefined;
  filtro: string = '';

  id_user: number = 0;
  pagedItems: any[] = [];
  currentPage: number = 1;
  //
  itemsPerPage: number = 5;
  totalItems: number = 0;

  tableSize: number[] = [5, 10, 15, 20];
  cantidad: number = 0;

  nroQR: number = 0;
  fechaCreacionQR: string = "";
  estadoQR: string = "";
  urlQR: string = "";
  idQrEliminacion: number = 0;
  idQrEdicion: number = 0;
  urlEdicionValue: string = '';
  p: number = 1; // Página actual
  isChecked: boolean = true; //

  // --- Personalización del QR mostrado en el modal "ver QR" (color + ícono) ---
  modalQrColor: string = '#000000';
  coloresPreset: string[] = ['#000000', '#DA291C', '#1E1E1E', '#5F6368', '#0B5FA5', '#1C7C3C'];
  modalQrLogoSrc: string | undefined = undefined;
  modalQrLogoSize: number = 50;
  private readonly LOGO_MAX_BYTES = 1024 * 1024; // 1MB

  get nivelCorreccionModal(): 'M' | 'H' {
    return this.modalQrLogoSrc ? 'H' : 'M';
  }

  constructor(
    private modulesService: QrService,
    private storage: StorageService,
    private route: Router,
    private storageService: StorageService,
    private toastr: ToastrService,
    private loadingService: LoadingService
  ) {

  }

  ngOnInit(): void {

    this.loadingService.show();
    const usuarioStorage = this.storage.getUsuarioStorage();

    if (!usuarioStorage || Object.keys(usuarioStorage).length === 0) {

      this.route.navigate(['/login']);
      this.loadingService.hide();
      // this.toastr.success('Hello world!', 'Toastr fun!');
    } else {
      this.id_user = usuarioStorage.idUser;
      // Sin este catch, un fallo de la API quedaba como unhandled rejection
      // silenciosa y la pantalla se limitaba a mostrar "0 codigos".
      this.ListaURL_Creadas().finally(() => this.loadingService.hide());
    }
  }

  async ListaURL_Creadas() {

    this.usuario = this.storage.getUsuarioStorage();
    this.esAdministrado = this.storage.esAdministrador();
    this.cantidad = 0;

    // El administrador ve los QR de todos los usuarios (id_usuario = 0);
    // el resto, únicamente los suyos.
    const idConsulta = this.esAdministrado ? 0 : this.id_user;

    try {
      // El backend devuelve Ok(null) (204) cuando la consulta falla, así que
      // sin este ?? [] un fallo del servidor reventaba en data.length y la
      // pantalla se quedaba muda en "0 codigos".
      const data: QR_List[] = (await this.modulesService.ListaURL_Creadas(idConsulta, 'todos')) ?? [];

      this.QR_List_List = data;
      this.cantidad = data.length;

      if (this.filtro != '') {
        this.QR_List_List = this.QR_List_List.filter(item =>
          item.url_qr.toLowerCase().includes(this.filtro) ||
          item.user?.toLowerCase().includes(this.filtro) ||
          this.formatearFecha(item.fecha_creacion).includes(this.filtro)
        );
      }
    } catch (error) {
      this.QR_List_List = [];
      this.cantidad = 0;
      this.loadingService.hide();
      this.toastr.error('No se pudo cargar la lista de códigos', 'Error');
    }
  }


  formatearFecha(fecha: any): string {
    const d = new Date(fecha);
    const dia = d.getDate().toString().padStart(2, '0');
    const mes = (d.getMonth() + 1).toString().padStart(2, '0');
    const anio = d.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  setPage(page: number) {
    const startIndex = (page - 1) * 10;
    const endIndex = Math.min(startIndex + 10, this.QR_List_List.length);
    this.pagedItems = this.QR_List_List.slice(startIndex, endIndex);

  }

  pageChanged(event: any) {
    this.currentPage = event;
    this.setPage(this.currentPage);
  }

  generarQRCode(rutaURL: any, valores: any) {
    this.nroQR = 0;
    console.log('Salida:' + JSON.stringify(valores));
    this.nroQR = valores.id_qr;
    this.fechaCreacionQR = valores.fecha_creacion;
    this.estadoQR = valores.estado;
    this.urlQR = valores.url_qr;
    this.myAngularxQrCode = rutaURL;
    //this.onChangeURL(rutaURL);

    // Recupera la personalización guardada para este QR (si la hay), para
    // que el modal recuerde el color/ícono elegido la última vez.
    const estiloGuardado = this.storageService.getEstiloQRRegistrado(valores.id_qr);
    this.modalQrColor = estiloGuardado?.color ?? '#000000';
    this.modalQrLogoSrc = estiloGuardado?.logoSrc;
    this.modalQrLogoSize = estiloGuardado?.logoSize ?? 50;
  }

  seleccionarColorModal(color: string) {
    this.modalQrColor = color;
  }

  onLogoSeleccionadoModal(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      this.toastr.error('El ícono debe ser una imagen (PNG, JPG, SVG)', 'ERROR');
      input.value = '';
      return;
    }
    if (file.size > this.LOGO_MAX_BYTES) {
      this.toastr.error('La imagen no debe superar 1MB', 'ERROR');
      input.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.modalQrLogoSrc = reader.result as string;
    };
    reader.onerror = () => {
      this.toastr.error('No se pudo leer la imagen seleccionada', 'ERROR');
    };
    reader.readAsDataURL(file);
  }

  quitarIconoModal(inputFile: HTMLInputElement) {
    this.modalQrLogoSrc = undefined;
    inputFile.value = '';
  }

  /** Guarda el color/ícono elegidos para este QR (por id_qr) en localStorage. */
  guardarPersonalizacionRegistrado(): void {
    if (!this.nroQR) {
      return;
    }
    const estilo: QR_Estilo = {
      color: this.modalQrColor,
      logoSrc: this.modalQrLogoSrc,
      logoSize: this.modalQrLogoSize
    };
    this.storageService.guardarEstiloQRRegistrado(this.nroQR, estilo);
    this.toastr.success('EXITO!', 'Personalización guardada para este QR');
  }



  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
    //  this.myAngularxQrCode= url;
  }

  ReporteDetallado(id_: any) {
    this.route.navigate(['/principal/reportes_detalle'], { queryParams: { id_query: id_ } });
  }

  downloadImage(dataURL: string, format: string) {
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `qrcode.${format}`;
    link.click();
  }

  downloadQRCode(format: string): void {
    try {
      // Busca el elemento del código QR en el DOM
      const qrElement = document.querySelector('qrcode canvas');
      if (!qrElement) {
        console.error('QR Code element not found.');
        this.toastr.error('ERROR', 'No se encontró el elemento del código QR.');
        return;
      }

      const canvas = qrElement as HTMLCanvasElement;
      const context = canvas.getContext('2d');

      let dataURL: string;
      if (format === 'png') {
        dataURL = canvas.toDataURL('image/png');
      } else if (format === 'jpeg') {
        dataURL = canvas.toDataURL('image/jpeg');
      } else if (format === 'svg') {
        const img = new Image();
        img.src = canvas.toDataURL('image/png');
        img.onload = () => {
          const svgData = new XMLSerializer().serializeToString(img);
          dataURL = 'data:image/svg+xml;base64,' + btoa(svgData);
          this.downloadImage(dataURL, format);
        };
        img.onerror = (e) => {
          console.error('Error loading image:', e);
          this.toastr.error('ERROR', 'Error al cargar la imagen.');
        };
        return;
      } else {
        //    console.error('Unsupported format');
        this.toastr.error('ERROR', 'Formato no soportado.');
        return;
      }

      this.downloadImage(dataURL, format);
    } catch (error) {
      //   console.error('Error in downloadQRCode:', error);
      this.toastr.error('ERROR', 'Ocurrió un error al descargar el código QR.');
    }
  }

  obtenerIdEliminacion(result: any) {
    this.idQrEliminacion = 0;
    this.idQrEliminacion = result.id_qr;
  }

  abrirEdicionURL(result: any) {
    this.idQrEdicion = result.id_qr;
    this.urlEdicionValue = result.url_qr;
  }

  guardarEdicionURL() {
    if (this.urlEdicionValue == null || this.urlEdicionValue.trim() == '') {
      this.toastr.info('ALERTA', 'La URL no puede estar vacía');
      return;
    }

    this.loadingService.show();
    this.entidad = new QR_registro();
    this.entidad.id_qr = this.idQrEdicion;
    this.entidad.url_qr = this.urlEdicionValue.trim();
    this.entidad.url_qr_redirec = '';
    this.entidad.id_usuario_creacion = this.storage.getUsuarioStorage()?.idUser ?? 0;

    const nuevaUrl = this.urlEdicionValue.trim();
    this.modulesService.GuardarURL(4, this.entidad).subscribe(
      message => {
        this.loadingService.hide();
        if (message[0].nro_respuesta == 0) {
          this.toastr.success('EXITO!', 'Se actualizó la URL correctamente');
          // Se actualiza el registro en la lista ya cargada (con una nueva
          // referencia de arreglo, ya que el pipe "paginate" es puro y no
          // vuelve a calcular la página visible si solo se muta un item)
          // en vez de volver a pedirla al backend: ese GET puede quedar
          // cacheado por el navegador y devolver datos desactualizados.
          this.QR_List_List = this.QR_List_List.map(item =>
            item.id_qr === this.idQrEdicion ? { ...item, url_qr: nuevaUrl } : item
          );
        } else {
          this.toastr.error(message[0].mensaje, 'ERROR');
        }
      },
      error => {
        this.loadingService.hide();
        this.toastr.error('No se pudo actualizar la URL. Intente nuevamente.', 'ERROR');
      }
    )
  }


  eliminarURL() {
    this.entidad = new QR_registro();
    this.entidad.id_qr = this.idQrEliminacion;
    this.entidad.url_qr = "";
    this.entidad.url_qr_redirec = "";
    this.entidad.id_usuario_creacion = this.storage.getUsuarioStorage()?.idUser ?? 0;
    this.entidad.estado = 1;

    this.modulesService.GuardarURL(99, this.entidad).subscribe(
      message => {
        if (message[0].nro_respuesta == 0) {
          // this.myAngularxQrCode = message[0].url;
          this.toastr.success('EXITO!', 'Se actualizo el estado correctamente');
          this.ListaURL_Creadas();
        }
      }
    )
  }

  desactivarURL(id_qr: any, estado_bool: number) {
    this.entidad = new QR_registro();
    this.entidad.id_qr = id_qr;
    this.entidad.url_qr = "";
    this.entidad.url_qr_redirec = "";
    this.entidad.id_usuario_creacion = this.storage.getUsuarioStorage()?.idUser ?? 0;
    if (estado_bool == 1) {
      this.entidad.estado = 0;
    } else {
      this.entidad.estado = 1;
    }
    this.modulesService.GuardarURL(3, this.entidad).subscribe(
      message => {
        if (message[0].nro_respuesta == 0) {
          // this.myAngularxQrCode = message[0].url;
          this.toastr.success('EXITO!', 'Se actualizo el estado correctamente');
          this.ListaURL_Creadas();
        }
      }
    )
  }


  salir() {
    this.storageService.removeUsuarioStorage();
    this.route.navigate(['/login/ingresar']);
  }
}
